import { Link } from '@tanstack/react-router'
import { FreeCutLogo } from '@/components/brand/freecut-logo'
import { Button } from '@/components/ui/button'
import { authConfig } from '@/features/auth/config'

interface AuthPageShellProps {
  title: string
  description: string
  footerText: string
  footerActionLabel: string
  footerActionTo: '/login' | '/register'
  children: React.ReactNode
}

export function AuthPageShell({
  title,
  description,
  footerText,
  footerActionLabel,
  footerActionTo,
  children,
}: AuthPageShellProps) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="mx-auto flex min-h-screen max-w-6xl flex-col px-6 py-8">
        <div className="flex items-center justify-between">
          <Link to="/" className="transition-opacity hover:opacity-80">
            <FreeCutLogo variant="full" size="md" />
          </Link>
          <div className="flex items-center gap-3">
            <Link to="/">
              <Button variant="outline">返回首页</Button>
            </Link>
            {authConfig.mainSiteUrl ? (
              <Button variant="outline" asChild>
                <a href={authConfig.mainSiteUrl}>返回主站</a>
              </Button>
            ) : null}
            <Link to="/projects">
              <Button variant="ghost">项目中心</Button>
            </Link>
          </div>
        </div>

        <div className="flex flex-1 items-center justify-center py-10">
          <div className="grid w-full max-w-5xl gap-8 lg:grid-cols-[1.15fr_0.85fr]">
            <div className="rounded-3xl border border-border bg-card/70 p-8 backdrop-blur">
              <div className="mb-8 max-w-xl space-y-4">
                <span className="inline-flex rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary">
                  快剪认证中心
                </span>
                <h1 className="text-4xl font-semibold tracking-tight">{title}</h1>
                <p className="text-base leading-7 text-muted-foreground">{description}</p>
              </div>

              <div className="grid gap-4 text-sm text-muted-foreground sm:grid-cols-3">
                <div className="rounded-2xl border border-border bg-background/60 p-4">
                  统一账户体系
                </div>
                <div className="rounded-2xl border border-border bg-background/60 p-4">
                  主站FastDo.tools登录可直达
                </div>
                <div className="rounded-2xl border border-border bg-background/60 p-4">
                  本站可独立登录
                </div>
              </div>
            </div>

            <div className="rounded-3xl border border-border bg-card p-8 shadow-sm">
              {children}
              <div className="mt-6 border-t border-border pt-6 text-sm text-muted-foreground">
                <span>{footerText}</span>{' '}
                <Link to={footerActionTo} className="font-medium text-primary hover:underline">
                  {footerActionLabel}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}